export default {"src":"/_next/static/media/NXE.260c5620.svg","height":18,"width":18};